export default "/images/dcd46329a7af1323d2f1709b59f6ff23.avif";